import React, { useEffect } from 'react';
import ChildOption from './Childoptions';
import { TextInput, MultiSelectInput } from '../../../../Helpers/Inputs/index';
import { Form } from 'react-bootstrap';

export default function IneligibleForm(props) {
  const getChildTextBox = (child, type) => {
    const ChildInputs = [];
    for (let i = 0; i < parseInt(child); i++) {
      let label = "";
      switch (i + 1) {
        case 1:
          label = "1st Child Name";
          break;
        case 2:
          label = "2nd Child Name";
          break;
        case 3:
          label = "3rd Child Name";
          break;
        case 4:
          label = "4th Child Name";
          break;
        case 5:
          label = "5th Child Name";
          break;
        case 6:
          label = "6th Child Name";
          break;
        case 7:
          label = "7th Child Name";
          break;
        case 8:
          label = "8th Child Name";
          break;
      }
      ChildInputs.push(
        <Form.Group key={`${props.formState.type} ${i} Children name`}>
          <TextInput
            id={`ineligible[${props.index}].nameofChildren[${i}].name`}
            name={`ineligible[${props.index}].nameofChildren[${i}].name`}
            value={props.formState.nameofChildren[i].name}
            onChange={(e) => props.onChange(`nameofChildren[${i}].name`, e.target.value, props.formState.type, `ineligible[${props.index}].nameofChildren[${i}].name`)}
            label={label}
            errors={props.errors && props.errors.nameofChildren[i] && props.errors.nameofChildren[i].name}
            inputRef={props.register}
          />
        </Form.Group>
      );
    }
    return ChildInputs;
  };
  useEffect(() => {
    const options = props.customOption ? props.customOption : [
      { value: 'Name of Proposed Insured', label: 'Name of Proposed Insured' },
      { value: 'Name of Spouse', label: 'Name of Spouse' },
      { value: 'Dependent Child', label: 'Dependent Child' }
    ];

    const valueOptions = []
    options.length > 0 && options.map((optionName) => {
      valueOptions.push(optionName.value);
    })
    if (props.formState.name !== "" && !valueOptions.includes(props.formState.name)) {
      // props.onChange('name', [], props.formState.type, `ineligible[${props.index}].name`)
    }
  })
  return (
    <div>
      <Form.Group>
        <MultiSelectInput
          selectOptions={props.customOption ? props.customOption : ''}
          id={`ineligible[${props.index}].name`}
          name={`ineligible[${props.index}].name`}
          value={props.formState.name}
          onChange={(e) => props.onChange('name', e.target.value, props.formState.type, `ineligible[${props.index}].name`)}
          label="Who?"
          errors={props.errors && props.errors.name}
          inputRef={props.register}
          renderLabelValue={true}
        />
      </Form.Group>

      {props.formState.name.includes('Dependent Child') && (
        <Form.Group>
          <ChildOption
            id={`ineligible[${props.index}].numberOfChildren`}
            name={`ineligible[${props.index}].numberOfChildren`}
            value={props.formState.numberOfChildren}
            state={props.state ? props.state : ''}
            noofchilds={props.noOfChilds ? props.noOfChilds : ''}
            onChange={(e) => props.ChildChange('numberOfChildren', e.target.value, props.formState.type, `ineligible[${props.index}].numberOfChildren`)}
            label="Number of Children"
            errors={props.errors && props.errors.numberOfChildren}
            inputRef={props.register}
          />
        </Form.Group>
      )}

      {props.formState.numberOfChildren && props.formState.name.includes('Dependent Child') && getChildTextBox(props.formState.numberOfChildren, props.formState.type)}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Quoters/Aflac/Helpers/Input/IneligibleForm.js